<div class="tw-fixed tw-left-6 tw-top-6 tw-z-20 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10"
  (click)="back()">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
  [iconName]="'arrow_back'"></cs-icon>
</div>
@if (totalCashBalance) {
  <div class="tw-fixed tw-top-6 tw-z-20 tw-flex tw-items-center tw-justify-center tw-gap-1 tw-px-4 tw-rounded-full tw-h-10 tw-border-2 tw-border-white tw-bg-teal-200 tw-right-18"
    (click)="openBottomSheet()">
    <cs-icon class="tw-h-6 tw-w-6"
    [iconName]="'cureskin_cash_coin'"></cs-icon>
    <p class="tw-font-bold tw-text-400">{{totalCashBalance}}</p>
  </div>
}
<div class="tw-fixed tw-right-6 tw-top-6 tw-z-20 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10"
  (click)="goToCart()">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
  [iconName]="'shopping_cart'"></cs-icon><span
class="tw-absolute tw-top-[2px] tw-right-[18%] tw-bg-black tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">{{numberOfProductsInCart}}</span>
</div>

<div
  #shopScrollContainer
  class="tw-flex flex-col tw-bg-gray-100 tw-h-full tw-overflow-x-hidden tw-overflow-y-auto"
  >
  <header class="tw-w-full tw-flex tw-flex-col tw-bg-teal-200 tw-text-center tw-bg-repeat-x tw-bg-top tw-pt-20 tw-px-0 tw-overflow-visible tw-pb-4 tw-top-0 tw-z-10 tw-mb-5"
    [class]="{ 'tw-mb-0': showCenterSearchResults, 'tw-mb-5': showCashBalance && !showCenterSearchResults, 'tw-sticky': stickyHeader}">
    <div class="tw-font-lexend tw-font-bold tw-text-600 tw-tracking-normal tw-capitalize"
      i18n="@@shopProducts">
      Shop products
    </div>
    <div
      class="tw-flex tw-items-center tw-justify-start tw-gap-3.5 tw-bg-white tw-rounded-xl tw-h-10 tw-w-11/12 tw-mx-auto tw-mt-5 tw-p-2.5">
      <cs-icon class="tw-h-6 tw-w-10 tw-text-teal-400 tw-border-r tw-border-r-solid tw-border-r-gray-200"
      [iconName]="'search_icon'"></cs-icon>
      <input class="tw-mx-auto tw-w-full tw-border-none"
        style="background-color: transparent"
        placeholder="Search for 'facewash'"
        data-testid="shop-search"
        [(ngModel)]="searchValue"
        (keyup)="fetchSearchData()"
        (click)="centerSearchClickedHandler()" />
    </div>
  </header>

  <!-- main content of shop page, this includes all the visible sections -->
  @if (!showCenterSearchResults && searchValue.length <= 2) {
    <div>
      <!-- Products in cart banner -->
      @if (productsInCartArray?.length) {
        <shop-order-banners
          [totalSp]="totalSP"
          [productsInCartArray]="productsInCartArray"
          [numberOfProductsInCart]="numberOfProductsInCart"
          [cartDiscount]="cartDiscount"
          [userDrImage]="userDrImage"
          [isShopRevampExperimentOn]="isShopRevampExperimentOn"
          [cartScriptBannerHeaderExperiment]="cartScriptBannerHeaderExperiment"
          (viewportVisibilityChange)="handleCompleteOrderBannerVisibility($event)"
        (goToCart)="goToCart()"></shop-order-banners>
      }
      <!-- Bogo section -->
      @if (isPersonalizedBogoExperiment && !isBogoProductsPending && personalizedBogoProducts?.length) {
        <div #bogoSection
          class="tw-flex tw-flex-col tw-gap-4 tw-pt-5 tw-pb-6 tw-bg-white tw-my-2"
          id="bogoSection"
          [class]="{'tw-mb-5': !isShopRevampExperimentOn}"
          [shopFirstRenderMarker]="'bogo_personalized'"
          (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)">
          <shop-carousels [sectionName]="appLanguageCode === appConfig.Shared.Languages.HI ? personalizedBogoTitle?.saleTitleHindi : personalizedBogoTitle?.saleTitle"
          [viewAllSection]="'bogoProduct'"></shop-carousels>
          <div class="tw-flex tw-items-stretch tw-gap-4 tw-px-5 tw-overflow-x-auto">
            @for (product of personalizedBogoProducts; track product) {
              <app-product
                [product]="product"
                [isShopRevampExperimentOn]="isShopRevampExperimentOn"
                [productInCart]="productsInCart[product?.objectId]"
                (addToCart)="addToCart($event, 'personalizedBogoProducts')"
                (reomveFromCart)="reomveFromCart($event)"
              (gotoProduct)="gotoProduct($event, 'personalizedBogoProducts')"></app-product>
            }
          </div>
        </div>
      }
      <!-- Bogo banner -->
      @if (isBOGOSaleLive && saleProducts?.length) {
        <div class="tw-flex tw-flex-col tw-gap-4 tw-my-2 tw-pt-5 tw-pb-6 tw-bg-white"
          [shopFirstRenderMarker]="'bogo_sale'"
          (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)">
          <shop-carousels [sectionName]="'Buy 1 Get 1'"
            [viewAllSection]="'bogoProduct'"
            [isShopRevampExperimentOn]="isShopRevampExperimentOn"
          [showTags]="false"></shop-carousels>
          <div class="tw-flex tw-items-stretch tw-gap-4 tw-px-5 tw-overflow-x-auto">
            @for (product of saleProducts; track product) {
              <app-product
                [product]="product"
                [productInCart]="productsInCart[product?.objectId]"
                [isShopRevampExperimentOn]="isShopRevampExperimentOn"
                (addToCart)="addToCart($event, 'saleProducts')"
                (reomveFromCart)="reomveFromCart($event)"
              (gotoProduct)="gotoProduct($event, 'saleProducts')"></app-product>
            }
          </div>
        </div>
      }
      @if (isBogoProductsPending) {
        <loader-shop></loader-shop>
      }
      <!-- Recently Viewed Products Section (hidden when recommended products is showing) -->
      @if (shouldRenderRecentlyViewed) {
        <recently-viewed-products [shopFirstRenderMarker]="'recently_viewed'"
          (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)"
          [location]="recentlyViewedLocation.SHOP"
          [recentlyViewedData]="recentlyViewedData"
          [cartData]="getCartDataForRecentlyViewed()"
          [isShopRevampExperimentOn]="isShopRevampExperimentOn">
        </recently-viewed-products>
      }
      <!-- Reorder -->
      @if (!isAddOnAndReorderPending && reorderProducts?.length) {
        <div #reorderProductsSection
          class="tw-flex tw-flex-col tw-gap-4 tw-pt-5 tw-pb-6 tw-bg-white tw-my-2"
          [class]="{'tw-mb-5': !isShopRevampExperimentOn}"
          [shopFirstRenderMarker]="'reorder'"
          (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)">
          <shop-carousels [sectionName]="'Reorder products'"
            [translateId]="'@@reorderProducts'"
            [viewAllSection]="'reorderProducts'"
          [isShopRevampExperimentOn]="isShopRevampExperimentOn"></shop-carousels>
          <div class="tw-flex tw-items-stretch tw-gap-4 tw-px-5 tw-overflow-x-auto">
            @for (product of reorderProducts; track product) {
              <app-product
                [product]="product"
                [productInCart]="getProductCartData(product?.objectId)"
                [isShopRevampExperimentOn]="isShopRevampExperimentOn"
                (addToCart)="addToCart($event, 'reorderProducts')"
                (reomveFromCart)="reomveFromCart($event)"
              (gotoProduct)="gotoProduct($event, 'reorderProducts')"></app-product>
            }
          </div>
        </div>
      }
      @if (isAddOnAndReorderPending) {
        <loader-shop></loader-shop>
      }
      @if (isRecommendedProductsShown) {
        <recommended-products class="tw-block tw-mt-2 tw-mb-2"
                              appTrackable pageName="shopPage" bannerName="shop-recommended-products"
                              [products]="recommendedProducts.products" [displayType]="recommendedProducts.displayType"></recommended-products>
      }
      <!-- Dynamic Banner -->
      @if (shopDynamicBanners.length) {
        <section class="tw-my-2 tw-pl-4 tw-py-6 tw-flex tw-flex-col tw-items-stretch tw-gap-3"
          [style.background-color]="dynamicBannerBackgroundColor || '#fff'">
          @if (dynamicBannerHeader) {
            <header class="tw-flex tw-items-center">
              <h2 class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-none">{{dynamicBannerHeader}}</h2>
            </header>
          }
          @if (shopDynamicBanners.length === 1) {
            <img class="tw-w-full tw-h-auto tw-pr-4 tw-rounded-xl"
              [src]="shopDynamicBanners[0].imageUrl"
              (click)="onDynamicBannerClick(shopDynamicBanners[0], 0)"
              alt="Shop banner" />
          } @else {
            <swiper class="swiper-wrapper"
              [config]="dynamicBannerSwiperConfig">
              @for (banner of shopDynamicBanners; track $index) {
                <div *swiperSlide class="tw-w-full">
                  <img class="tw-w-full tw-h-auto tw-pr-4"
                    [class.tw-cursor-pointer]="banner.navigationUrl"
                    [src]="banner.imageUrl"
                    (click)="onDynamicBannerClick(banner, $index)"
                    alt="Shop banner" />
                </div>
              }
            </swiper>
            <div id="dynamic-banner-pagination"
            class="tw-w-auto tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mt-3"></div>
          }
        </section>
      }
      <!-- Recommended products -->
      @if (shouldShowRecommendedSection) {
        <div #recommendedProductsSection
          class="tw-flex tw-flex-col tw-gap-4 tw-pt-5 tw-pb-6 tw-bg-white tw-my-2"
          [shopFirstRenderMarker]="'recommended'"
          (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)">
          <shop-carousels [sectionName]="'Recommended products for you'"
            [translateId]="'@@recommProductsForYou'"
            [viewAllSection]="'recommendedProducts'"
          [isShopRevampExperimentOn]="isShopRevampExperimentOn"></shop-carousels>
          <div class="tw-flex tw-items-stretch tw-gap-5 tw-px-5 tw-overflow-x-auto">
            @for (product of addOnProducts; track product) {
              <app-product
                [product]="product"
                [isShopRevampExperimentOn]="isShopRevampExperimentOn"
                [productInCart]="getProductCartData(product?.objectId)"
                (addToCart)="addToCart($event, 'recommendedProducts')"
                (reomveFromCart)="reomveFromCart($event)"
              (gotoProduct)="gotoProduct($event, 'recommendedProducts')"></app-product>
            }
          </div>
        </div>
      }
      @if (isAddOnAndReorderPending) {
        <loader-shop></loader-shop>
      }
      @if (isShopRevampExperimentOn) {
        @for (name of shopSectionOrder; track $index;) {
          @let displayType = shopCollections[name]?.displayType;
          @if (!displayType && name !== 'filter-strip') {
            <app-loader-shop-revamp></app-loader-shop-revamp>
          } @else {
            <!-- Section type -->
            @if (displayType === 'STANDARD') {
              <app-product-collection [id]="name"
                class="tw-block tw-mb-2 tw-scroll-mt-48"
                [shopFirstRenderMarker]="'collection_' + name"
                (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)"
                [collection]="shopCollections[name]"
                (viewCollection)="viewCollection($event)">
                @for (product of shopCollections[name]?.products; track $index) {
                  <app-product [product]="product"
                    [productInCart]="getProductCartData(product?.objectId)"
                    [isShopRevampExperimentOn]="isShopRevampExperimentOn"
                    (addToCart)="addToCart($event, name)"
                    (reomveFromCart)="reomveFromCart($event)"
                    (gotoProduct)="gotoProduct($event, name)" />
                }
              </app-product-collection>
            }
            <!-- Banner type -->
            @if (displayType === 'BANNER' || $any(displayType) === 'PURPOSE_SUBTEXT_BANNER' || $any(displayType) === 'PURPOSE_HEADER_BANNER') {
              <app-product-collection-banner [id]="name"
                class="tw-block tw-mb-2 tw-scroll-mt-48"
                [shopFirstRenderMarker]="'collection_' + name"
                (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)"
                [collection]="shopCollections[name]"
                (viewCollection)="viewCollection($event)">
                <swiper class="swiper-wrapper tw-mb-4"
                  [config]="getSwiperConfig($index, name)">
                  @for (product of shopCollections[name]?.products; track $index) {
                    <app-product-horizontal *swiperSlide
                      [product]="product"
                      [type]="displayType"
                      [productInCart]="getProductCartData(product?.objectId)"
                      (addToCart)="addToCart($event, name)"
                      (reomveFromCart)="reomveFromCart($event)"
                      (gotoProduct)="gotoProduct($event, name)" />
                  }
                </swiper>
                <div class="tw-w-auto tw-flex tw-items-center tw-gap-1 tw-mx-auto tw-overflow-auto"
                [id]="'swiper-pagination-' + $index"></div>
              </app-product-collection-banner>
            }
          }
          <!-- Jumbo type -->
          @if (displayType === 'ENLARGED_CARDS') {
            <app-product-collection-jumbo [id]="name"
              class="tw-block tw-mb-2 tw-scroll-mt-48"
              [shopFirstRenderMarker]="'collection_' + name"
              (shopFirstRenderMarkerRendered)="onFirstSectionRendered($event)"
              [collection]="shopCollections[name]"
              [products]="shopCollections[name]?.products"
              [productInCart]="productsInCart"
              [isInfiniteLoopEnabled]="isInfiniteLoopEnabled"
              (viewCollection)="viewCollection($event)"
              (addToCart)="addToCart($event, name)"
              (reomveFromCart)="reomveFromCart($event)"
              (gotoProduct)="gotoProduct($event, name)">
            </app-product-collection-jumbo>
          }
          <!-- Filter Strip -->
          @if (name === 'filter-strip') {
            <app-shop-collection-nav class="tw-block tw-mb-2"
              [order]="shopSectionFilterStrip"
              [collections]="shopCollections"
              (gotoCollection)="scrollToSectionById($event)">
            </app-shop-collection-nav>
          }
        }
      }
      <!-- show all -->
      @if (!loading) {
        <div class="tw-flex tw-justify-space-between tw-items-center tw-flex-row tw-pl-4"
          (click)="exploreAll()"
          [ngClass]='{ "tw-mb-[148px]": !aovTask, "tw-mb-[200px]": aovTask }'>
          <div class="tw-flex-1 tw-flex tw-flex-col">
            <div class="tw-font-body tw-font-bold tw-text-600 tw-text-black"
              i18n="@@shopAll">
          Shop all
        </div>
        <div class="tw-font-body tw-text-200 tw-text-black"
             i18n="@@shopAllProducts">
          Cure products
        </div>
          </div>
          <div
            class="tw-flex-none tw-h-8 tw-w-8 tw-rounded-full tw-m-4 tw-flex tw-items-center tw-justify-center tw-bg-teal-600 tw-text-white">
            <em class="cs-icon-arrow"></em>
          </div>
        </div>
      }
    </div>
  }

  <!-- search loading -->
  @if (!showCenterSearchResults && loading && searchValue.length > 2) {
    <div
      class="tw-h-full tw-flex tw-items-center tw-justify-center">
      <loading></loading>
    </div>
  }

  <!-- search result  -->
  @if (showCenterSearchResults && !loading && searchValue.length > 2) {
    <div
      class="tw-flex tw-flex-col tw-font-body"
      [class]="{ 'tw-pb-36': !aovTask, 'tw-pb-[254px]': aovTask }">
      <ul class="tw-py-2 tw-px-4">
        @for (item of searchResultTexts; track item) {
          <li
            class="tw-flex items-center tw-py-2 tw-px-6"
            (click)="selectAutocomplete(item)">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-teal-400 tw-mr-2"
            [iconName]="'search_icon'"></cs-icon>
            {{ item.title }}
          </li>
        }
      </ul>
      <div class="tw-h-full tw-grid tw-grid-cols-2 tw-gap-2 tw-px-4">
        @for (product of searchResultProducts; track $index) {
          <div class="tw-items-center tw-flex tw-flex-col tw-justify-between tw-h-full">
            <app-product-card class="tw-animate-anim_fadeIn"
              [product]="product"
              [productInCart]="productsInCart[product?.objectId]"
              (addToCart)="addToCart($event, 'advanceSearchProduct')"
              (reomveFromCart)="reomveFromCart($event)"
              (gotoProduct)="gotoProduct($event, 'advanceSearchProduct')">
            </app-product-card>
          </div>
        }
        @if (!searchResultProducts.length) {
          <div class="tw-text-center tw-leading-[1.8rem] tw-font-normal tw-text-[1.1rem]"
            i18n="@@noProductsAvailable">
        No products available
      </div>
        }
      </div>
    </div>
  }

  @if (isDiscontinued) {
    <pop-up
      [class]="'bdr-rad-10 p15 popup-ht-unset'"
      [show]="isDiscontinued"
      [triggerDismiss]="true"
      (close)="closePopup()">
      <discontinued-popup [oldProductData]="oldProduct"
        [newProductData]="newProduct"
        (changeProduct)="changeProduct()"
      (articleOpen)="openArticle()"></discontinued-popup>
    </pop-up>
  }

  @if (shouldShowCartDetailStrip) {
    <cart-detail-strip
      [numberOfProductsInCart]="numberOfProductsInCart"
      [user]="user"
      [cashBalance]="totalCashBalance"
      [cart]="cart"
      [totalSp]="totalSP"
    (closeStrip)="isCheckoutStickyVisible = false"></cart-detail-strip>
  }

  @if (aovTask && isAOVActive && !loading && !newCartUI && !orderFlowHeader && searchValue?.length <= 2) {
    <aov-sale
      [numberOfProductsInCart]="numberOfProductsInCart"
      [maxPrice]="maxPrice"
      [showConfettiAnimation]="showConfettiAnimation"
      [barStyle]="barStyle"
      [cart]="cart"
      [user]="user"
      [userLanguageKnOrTa]="userLanguageKnOrTa"
      [prodImage]="prodImage"
      [amountRemaining]="amountRemaining"
      [totalSP]="totalSP"
    (onCheckout)="checkout()"></aov-sale>
  }
  @if (aovTask && isAOVActive && !loading && (newCartUI || orderFlowHeader) && searchValue?.length <= 2) {
    <div
      class="tw-absolute tw-w-full tw-h-32 tw-bottom-6">
      <app-aov-banner [amountRemaining]="amountRemaining"
        [freeProductBannerImage]="prodImage"
        [percentageDone]="percentageDone"
            [shouldShowConfetti]="showConfettiAnimation"
        [isEnglishLanguage]="user?.get('languagePreference') === appConfig.Shared.Languages.EN"
      [displayWhenAmountRemainingIsZero]="true"></app-aov-banner>
    </div>
  }
</div>
